import { useMutation, useQueryClient } from 'react-query';
import { cacheKeys } from './cacheKeys';
import { handleRequest } from '../../../../redux/services/APIService';
import storageHelper from '../../../../libs/storageHelper';
import { toast } from 'react-toastify';

export const useUpdateAppointmentTypes = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation(
    async (data = [{ title: '', order: '', isCustom: true }]) => {
      const { user } = storageHelper.getFromStorage('loggedUser');
      return handleRequest(
        'put',
        `facility/${user.facility}/appointment-types`,
        true,
        data,
      );
    },
    {
      onSuccess: async () => {
        toast('Appointment Types were successfully updated', {
          type: 'success',
          style: { width: 'auto' },
        });
        queryClient.invalidateQueries([cacheKeys.getAppointmentTypes()]);
      },
      onError: async (err) => {
        toast('Unable to update Appointment Types', {
          type: 'error',
          style: { width: 'auto' },
        });
        console.error(
          `Failed to update Appointment Types: ${
            err.response?.data.message || err.message
          }`,
        );
      },
    },
  );

  return mutation;
};
